<script>
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'GoodsCharacteristicItem',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      newItem: {
        id: null,
        goods: null,
        characteristic: null,
        value: null,
      },
      rules: {
        goods: [x => !!x || this.$t('validation__is_required')],
        characteristic: [x => !!x || this.$t('validation__is_required')],
        value: [x => !!x || this.$t('validation__is_required')],
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
    }
  },
  computed: {
    isChanged() {
      return !isEqual(this.item, this.newItem)
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    characteristic() {
      const unusedCharacteristics = [119, 120, 121]
      return this.$store.getters['data/getDictionary']('characteristic').filter(
        elem => !unusedCharacteristics.includes(elem.code)
      )
    },
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    unitsMeasurementHint() {
      if (!this.newItem.characteristic) return ''
      if (
        this.newItem.characteristic === 120 ||
        (this.newItem.characteristic >= 107 &&
          this.newItem.characteristic <= 110)
      )
        return ''
      if (this.newItem.characteristic === 121) return 'label__g_to_cm'
      return this.newItem.characteristic === 114
        ? `label__${this.unitsMeasurement.volumeMeasure}`
        : `label__${this.unitsMeasurement.lengthMeasure}`
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  watch: {
    item: {
      handler(val) {
        let value
        if (!isEmpty(val)) {
          if (val.characteristic > 110 && val.characteristic < 119) {
            value = parseFloat(val.value)
            if (val.characteristic === 114) {
              value /= this.unitsMeasurement.volumeMultiplier
            } else {
              value /= this.unitsMeasurement.lengthMultiplier
            }
          } else value = val.value
          Object.assign(this.newItem, {
            ...val,
            value,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="500px">
    <v-card>
      <v-card-title>
        <div class="headline">
          {{ $t('titles__update_goods_characteristic') }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form 
                ref="editForm" 
                v-model="valid" 
                lazy-validation>
                <v-select
                  :items="goods"
                  :label="$t('label__goods')"
                  v-model="newItem.goods"
                  :rules="rules.goods"
                  item-text="shortName"
                  item-value="id"
                  required
                  readonly
                  autocomplete
                />
                <v-select
                  :items="characteristic"
                  :label="$t('label__characteristic')"
                  :readonly="!userAllowedToUpdate"
                  v-model="newItem.characteristic"
                  :rules="rules.characteristic"
                  item-text="name"
                  item-value="code"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__value')"
                  :readonly="!userAllowedToUpdate"
                  v-model="newItem.value"
                  :hint="$t(unitsMeasurementHint)"
                  persistent-hint
                  name="value"
                  required
                />
              </v-form>
              <small>* {{ $t('label__requier_small_text') }}</small>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn 
          color="secondary" 
          @click="$emit('edit-canceled')">{{
            $t('buttons__close')
          }}</v-btn>
        <v-btn 
          v-if="userAllowedToUpdate" 
          color="success" 
          disabled>{{
            $t('buttons__update')
          }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
